/**
 * The Romford Bull - Theme JavaScript
 * Professional Boxing Theme for Johnny Fisher
 */

(function() {
  'use strict';

  // Initialize theme when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTheme);
  } else {
    initTheme();
  }

  function initTheme() {
    initMobileMenu();
    initCart();
    initQuantitySelectors();
    initImageZoom();
    initScrollEffects();
    initSearchModal();
    initSecondaryNav();
  }

  // ===========================
  // Mobile Menu Toggle (Secondary Nav)
  // ===========================
  function initMobileMenu() {
    const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
    const nav = document.querySelector('.secondary-nav');

    if (!menuToggle || !nav) return;

    menuToggle.addEventListener('click', function() {
      nav.classList.toggle('mobile-active');
      const isOpen = nav.classList.contains('mobile-active');
      menuToggle.setAttribute('aria-expanded', isOpen);
      
      // Prevent body scroll when menu is open
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Close menu when clicking outside
    document.addEventListener('click', function(e) {
      if (!nav.contains(e.target) && !menuToggle.contains(e.target)) {
        nav.classList.remove('mobile-active');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  // ===========================
  // Cart Functionality
  // ===========================
  function initCart() {
    const cartIcon = document.querySelector('[data-cart-icon]');
    const cartDrawer = document.querySelector('[data-cart-drawer]');
    const cartClose = document.querySelector('[data-cart-close]');

    if (cartIcon && cartDrawer) {
      cartIcon.addEventListener('click', function(e) {
        e.preventDefault();
        cartDrawer.classList.add('cart-drawer--open');
        document.body.style.overflow = 'hidden';
      });
    }

    if (cartClose && cartDrawer) {
      cartClose.addEventListener('click', function() {
        cartDrawer.classList.remove('cart-drawer--open');
        document.body.style.overflow = '';
      });
    }

    // Update cart count
    updateCartCount();
  }

  function updateCartCount(animate) {
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        const cartCount = document.querySelector('[data-cart-count]');
        const cartCountTop = document.querySelector('[data-cart-count-top]');
        const cartTotal = document.querySelector('[data-cart-total]');
        const cartIcon = document.querySelector('[data-cart-icon]');
        
        if (cartCount) {
          cartCount.textContent = cart.item_count;
          cartCount.style.display = cart.item_count > 0 ? 'inline-block' : 'none';
          
          // Animate if requested
          if (animate && cart.item_count > 0) {
            cartCount.classList.remove('cart-count--updated');
            void cartCount.offsetWidth; // Trigger reflow
            cartCount.classList.add('cart-count--updated');
            
            if (cartIcon) {
              cartIcon.classList.add('site-nav__icon--pulse');
              setTimeout(function() {
                cartIcon.classList.remove('site-nav__icon--pulse');
              }, 500);
            }
          }
        }
        
        // Update top bar cart info
        if (cartCountTop) {
          cartCountTop.textContent = cart.item_count;
        }
        
        const cartCountTopMobile = document.querySelector('[data-cart-count-top-mobile]');
        if (cartCountTopMobile) {
          cartCountTopMobile.textContent = cart.item_count;
        }
        
        // Note: Cart total is handled by Shopify's money_with_currency filter
        // We don't update it here to preserve the correct currency display
      })
      .catch(function(error) {
        console.error('Error fetching cart:', error);
      });
  }

  // ===========================
  // Quantity Selectors
  // ===========================
  function initQuantitySelectors() {
    const quantityInputs = document.querySelectorAll('[data-quantity-input]');

    quantityInputs.forEach(function(input) {
      const decreaseBtn = input.parentElement.querySelector('[data-quantity-decrease]');
      const increaseBtn = input.parentElement.querySelector('[data-quantity-increase]');

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function() {
          const currentValue = parseInt(input.value, 10);
          if (currentValue > 1) {
            input.value = currentValue - 1;
            input.dispatchEvent(new Event('change'));
          }
        });
      }

      if (increaseBtn) {
        increaseBtn.addEventListener('click', function() {
          const currentValue = parseInt(input.value, 10);
          input.value = currentValue + 1;
          input.dispatchEvent(new Event('change'));
        });
      }
    });
  }

  // ===========================
  // Image Zoom on Product Pages
  // ===========================
  function initImageZoom() {
    const productImages = document.querySelectorAll('[data-product-image]');

    productImages.forEach(function(img) {
      img.addEventListener('click', function() {
        const modal = document.createElement('div');
        modal.className = 'image-modal';
        modal.innerHTML = '<div class="image-modal__overlay"></div><img src="' + img.src + '" class="image-modal__image"><button class="image-modal__close">&times;</button>';
        document.body.appendChild(modal);
        document.body.style.overflow = 'hidden';

        setTimeout(function() {
          modal.classList.add('image-modal--active');
        }, 10);

        const closeModal = function() {
          modal.classList.remove('image-modal--active');
          setTimeout(function() {
            document.body.removeChild(modal);
            document.body.style.overflow = '';
          }, 300);
        };

        modal.querySelector('.image-modal__close').addEventListener('click', closeModal);
        modal.querySelector('.image-modal__overlay').addEventListener('click', closeModal);
      });
    });
  }

  // ===========================
  // Scroll Effects
  // ===========================
  function initScrollEffects() {
    const header = document.querySelector('.site-header');

    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;

      // Add shadow to header when scrolled
      if (currentScroll > 10) {
        if (header) header.classList.add('site-header--scrolled');
      } else {
        if (header) header.classList.remove('site-header--scrolled');
      }
    });

    // Animate elements on scroll
    const animateElements = document.querySelectorAll('[data-animate]');
    
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    animateElements.forEach(function(el) {
      observer.observe(el);
    });
  }

  // ===========================
  // Add to Cart
  // ===========================
  window.addToCart = function(formElement) {
    // Check if add to cart button is disabled (out of stock)
    const addToCartButton = formElement.querySelector('[data-add-to-cart]');
    if (addToCartButton && addToCartButton.disabled) {
      showNotification('This item is currently out of stock', 'error');
      return false;
    }
    
    const formData = new FormData(formElement);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      // Check if the response indicates the item is unavailable
      if (data.status && data.status === 422) {
        showNotification('This item is no longer available', 'error');
        return;
      }
      
      // Update cart count with animation
      updateCartCount(true);
      
      // Show success message
      showNotification('Item added to cart!', 'success');
      
      // Open cart drawer if it exists
      const cartDrawer = document.querySelector('[data-cart-drawer]');
      if (cartDrawer) {
        cartDrawer.classList.add('cart-drawer--open');
        document.body.style.overflow = 'hidden';
      }
    })
    .catch(function(error) {
      console.error('Error adding to cart:', error);
      showNotification('Error adding item to cart', 'error');
    });

    return false;
  };

  // ===========================
  // Notification System
  // ===========================
  function showNotification(message, type) {
    const notification = document.createElement('div');
    notification.className = 'notification notification--' + type;
    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(function() {
      notification.classList.add('notification--show');
    }, 10);

    setTimeout(function() {
      notification.classList.remove('notification--show');
      setTimeout(function() {
        document.body.removeChild(notification);
      }, 300);
    }, 3000);
  }

  // ===========================
  // Search Modal
  // ===========================
  function initSearchModal() {
    const searchToggle = document.querySelector('[data-search-toggle]');
    const searchSlide = document.querySelector('[data-search-slide]');
    const searchClose = document.querySelectorAll('[data-search-close]');
    const searchInput = document.querySelector('[data-search-input]');
    const searchResults = document.querySelector('[data-search-results]');
    let searchTimeout;

    if (!searchToggle || !searchSlide) return;

    // Open search slide
    searchToggle.addEventListener('click', function(e) {
      e.preventDefault();
      searchSlide.classList.add('search-slide--open');
      setTimeout(function() {
        searchInput.focus();
      }, 200);
    });

    // Close search slide
    searchClose.forEach(function(btn) {
      btn.addEventListener('click', function() {
        searchSlide.classList.remove('search-slide--open');
        searchInput.value = '';
        searchResults.innerHTML = '';
      });
    });

    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchSlide.classList.contains('search-slide--open')) {
        searchSlide.classList.remove('search-slide--open');
        searchInput.value = '';
        searchResults.innerHTML = '';
      }
    });

    // Close when clicking outside
    document.addEventListener('click', function(e) {
      if (searchSlide.classList.contains('search-slide--open') && 
          !searchSlide.contains(e.target) && 
          !searchToggle.contains(e.target)) {
        searchSlide.classList.remove('search-slide--open');
        searchInput.value = '';
        searchResults.innerHTML = '';
      }
    });

    // Live search
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        const query = this.value.trim();

        clearTimeout(searchTimeout);

        if (query.length < 2) {
          searchResults.innerHTML = '';
          return;
        }

        searchTimeout = setTimeout(function() {
          performSearch(query, searchResults);
        }, 300);
      });
    }
  }

  function performSearch(query, resultsContainer) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        displaySearchResults(data, resultsContainer);
      })
      .catch(function(error) {
        console.error('Search error:', error);
      });
  }

  function displaySearchResults(data, container) {
    if (!data.resources || !data.resources.results || !data.resources.results.products) {
      container.innerHTML = '<div class="search-empty"><i class="fas fa-search"></i><p>No products found</p></div>';
      return;
    }

    const products = data.resources.results.products;

    if (products.length === 0) {
      container.innerHTML = '<div class="search-empty"><i class="fas fa-search"></i><p>No products found</p></div>';
      return;
    }

    const resultsHTML = products.map(function(product) {
      const image = product.image || '';
      
      return '<a href="' + product.url + '" class="search-result">' +
        '<img src="' + image + '" alt="' + product.title + '" class="search-result__image">' +
        '<div class="search-result__info">' +
          '<div class="search-result__title">' + product.title + '</div>' +
        '</div>' +
      '</a>';
    }).join('');

    container.innerHTML = resultsHTML;
  }

  // ===========================
  // Secondary Navigation Dropdowns
  // ===========================
  function initSecondaryNav() {
    const dropdownToggles = document.querySelectorAll('.secondary-nav__link:not(.secondary-nav__link--plain)');
    
    dropdownToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        
        // Close all other dropdowns
        dropdownToggles.forEach(function(otherToggle) {
          if (otherToggle !== toggle) {
            otherToggle.setAttribute('aria-expanded', 'false');
          }
        });
        
        // Toggle current dropdown
        toggle.setAttribute('aria-expanded', !isExpanded);
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.secondary-nav__item')) {
        dropdownToggles.forEach(function(toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  // ===========================
  // Expose public API
  // ===========================
  window.theme = window.theme || {};
  window.theme.updateCartCount = updateCartCount;
  window.theme.showNotification = showNotification;

})();
